// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import './i18n';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import { createRoot } from 'react-dom/client';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

import 'dayjs/locale/es';

dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.locale('es');
dayjs.extend(utc);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

reportWebVitals();


